import { Card, Button, Row, Col } from "antd"
import moment from "moment"
import "moment/locale/ja"
import React from "react"
import { Helmet } from "react-helmet-async"

moment.updateLocale("ja")

const ReservationList = (props) => {
  return (
    <>
      <Helmet>
        <title>配達一覧 | {process.env.REACT_APP_SYSTEM_NAME}</title>
      </Helmet>
      <Card
        title="取置き一覧"
        className="animate__animated animate__fadeIn"
        bordered={false}
      >
        <Row>
          <Col xs={24}>
            <p>
              スマレジ
              <Button
                type="link"
                href={process.env.REACT_APP_SMAREGI_POS_LAYAWAY_URL}
                target="_blank"
                className=" text-smaregi m-0 p-0"
              >
                「取置き履歴一覧」
              </Button>
              にてご確認ください。
            </p>
          </Col>
        </Row>
      </Card>
    </>
  )
}

export default ReservationList
